import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { useNotifications } from "@toolpad/core";
import React, { useState } from "react";
import { changePassword } from "../services/adminService";
import ConfirmationModal from "./modal/ConfirmationModal";

export default function AdminChangePasswordModal({
  cisloOdberatele,
  setModalVisible,
}) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [error, setError] = useState("");
  const notifications = useNotifications();

  const onSubmit = (e) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      setError("Hesla se neshodují.");
      return;
    }
    // TODO add password validation
    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmed = async () => {
    const response = await changePassword(cisloOdberatele, newPassword);
    if (response?.success === true) {
      setError("");
      setConfirmModalOpen(false);
      setModalVisible(false);
      notifications.show("Heslo bylo úspěšně změněno.", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      setError(response.message || "Neznámá chyba.");
    }
  };
  return (
    <Box component="form" onSubmit={onSubmit} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Změna hesla odběratele č. {cisloOdberatele}
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <TextField
        type="password"
        label="Nové heslo"
        variant="outlined"
        size="small"
        fullWidth
        value={newPassword}
        autoComplete="off"
        onChange={(e) => setNewPassword(e.target.value)}
        sx={{ mb: 1 }}
      />
      <TextField
        type="password"
        label="Nové heslo znovu"
        variant="outlined"
        size="small"
        fullWidth
        value={confirmNewPassword}
        autoComplete="off"
        onChange={(e) => setConfirmNewPassword(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Button
        type="submit"
        variant="contained"
        sx={{ display: "block", width: "fit-content", margin: "0 auto" }}
      >
        Uložit
      </Button>
      {confirmModalOpen && (
        <ConfirmationModal
          visible={confirmModalOpen}
          setVisible={setConfirmModalOpen}
          title="Potvrzení změny"
          message={`Opravdu si přejete změnit heslo`}
          onConfirm={handleSubmitConfirmed}
        />
      )}
    </Box>
  );
}
